// /Users/pramod/Desktop/school-erp/frontend/src/Tenant-Admin/ManageStaff/StaffBulkActions.js
import React from 'react';
import { Trash2, CheckSquare, X } from 'lucide-react';

const StaffBulkActions = ({ selectedCount, onClear, onDelete }) => (
  <div className="bg-slate-900 border border-slate-950 text-white rounded-xl p-3.5 mb-6 shadow-md animate-fadeIn">
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
      
      {/* Selection Status Label */}
      <div className="flex items-center gap-2 min-w-0">
        <CheckSquare size={16} className="text-indigo-400 shrink-0" />
        <span className="text-xs font-bold tracking-wide truncate">
          {selectedCount} staff profile{selectedCount !== 1 ? 's' : ''} highlighted
        </span>
      </div>
      
      {/* Batch Control Action Buttons Row */}
      <div className="flex items-center gap-2 w-full sm:w-auto justify-end">
        <button
          type="button"
          onClick={onClear}
          className="h-8 px-3 text-xs font-bold text-slate-300 hover:text-white transition-colors flex items-center gap-1 bg-slate-800 hover:bg-slate-700/80 rounded-lg"
        >
          <X size={13} />
          <span>Clear</span>
        </button>
        
        <button
          type="button"
          onClick={onDelete}
          className="h-8 px-3 bg-rose-600 hover:bg-rose-700 text-white rounded-lg transition-colors text-xs font-bold flex items-center gap-1.5 shadow-sm shadow-rose-950/20"
        >
          <Trash2 size={13} />
          <span>Delete Batch</span>
        </button>
      </div>

    </div>
  </div>
);

export default StaffBulkActions;